<template>
  <!--先判定微信和非微信-->
  <div id="Jump">
    <!--显示刷新页面,只有在微信浏览器并且没有登录的时候才会显示-->
    <div class="jump_flush_page">
        <div class="jump_flush_album_div" v-on:click="close($event)">关闭finish</div>
      <div class="jump_flush_album_div" v-on:click="showStatus($event)">showStatus</div>

      <div class="jump_flush_album_div" v-on:click="hideStatus($event)">hideStatus</div>

      <div class="jump_flush_album_div" v-on:click="updateStatusBar($event)">updateStatusBar</div>
    </div>
  </div>
</template>

<style>
  #Jump{
    width: 100%;
    height: 100%;
  }
  .jump_flush_page{
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;

    justify-content: center;
    align-items: center;


    background-color: #51a938;
  }
  .jump_flush_album_div{
    width: 280px;
    height: 50px;

    margin-top: 40px;

    justify-content: center;
    display: flex;
    align-items: center;

    font-size: 20px;
    color: #333333;

    border: 2px solid #333333;
    border-radius: 8px;

    color: #333333;
    /*background-color: #fe5870;*/
  }
</style>

<script>
  export default {
    name: 'Jump',
    data () {
      console.log("ssss")
      return {
      }
    },
    mounted() {
    },
    methods:{
      close(event){///重新加载页面
        alert("点击了界面")
        window.android.popToApp();
      },
      showStatus(event){///重新加载页面
        alert("点击了界面")
        window.android.showStatus();
      },
      hideStatus(event){///重新加载页面
        alert("点击了界面")
        window.android.hideStatus();
      },
      updateStatusBar(event){///改变颜色
        alert("点击了界面")
        window.android.updateStatusBar("#ff0000");
      },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Jump.vue